/** @format */

import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'cart-checkout-components-checkout-wysiwyg',
	templateUrl: './checkout-wysiwyg.component.html',
	styleUrl: './checkout-wysiwyg.component.scss',
	encapsulation: ViewEncapsulation.None, // Need this in order to overwrite innterHtml styles
	standalone: false
})
export class CheckoutWysiwygComponent implements OnInit {
	@Input() addlData: any;
	@Input() data: any[];

	blocks: string[] = [];

	public ngOnInit() {
		if (this.data) {
			this.makeBlocks();
		}
	}

	private makeBlocks() {
		for (const datum of this.data) {
			this.blocks.push(decodeURIComponent(datum.wysiwyg));
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	trackByFn(index: number, _item: any): number {
		return index;
	}
}
